import(/* webpackMode: "eager", webpackExports: ["CapabilityDetail"] */ "C:\\apps\\enginuity\\components\\pages.jsx");
